import { compose, mapProps } from 'recompose';
import camelize from 'camelize';
import queryString from 'query-string';
import config from '../../../config';
import { withFetchOnMount } from '../../Common/Spinner';
import { showErrorMsg } from '../ErrorMsg';

export const getPromotionUrl = `${config.localeApi}/promotions`;

const getData = (params = {}) => {
  const queryParams = queryString.stringify(params);
  const promoUrl = queryParams.length > 0
    ? `${getPromotionUrl}?${queryParams}`
    : getPromotionUrl;

  return $.get(promoUrl)
    .fail((resp) => {
      const { errors = null } = resp.responseJSON;
      if (errors) {
        const msg = Object.keys(errors)
          .map(key => (errors[key].join('')))
          .join('<br/>');
        toastr.warning(msg);
      }
    });
};

export const withPromotionData = (params = {}) => WrappedComponent => compose(
  withFetchOnMount(() => getData(params)),
  mapProps(({ loading, data, ...keys }) => ({
    promotions: camelize(data.data),
    ...keys,
  })),
)(WrappedComponent);

export const getPaginatedPromotionGroups = (type, params = {}) => {
  const queryParams = queryString.stringify(params);

  return $.get(`${config.localeApi}/promotion_groups/index/${type}?${queryParams}`)
    .fail(({ responseJSON: { errors = '' } }) => {
      showErrorMsg(errors);
    });
};

export const getPromotionFilterList = (promotionType) => {
  return $.get(`${config.localeApi}/promotions/${promotionType}/filter`)
    .fail(({ responseJSON: { errors = '' } }) => {
      showErrorMsg(errors);
    });
}

export const addPromotionToCart = (promotionId, isCrossSell = false, quantity = 1) => {
  return $.ajax({
    url: `${config.localeApi}/cart/promotion`,
    data: JSON.stringify({ promotion_id: promotionId, is_cross_sell: isCrossSell, quantity }),
    contentType: 'application/json',
    method: 'POST',
    dataType: 'json',
  });
}

export const addPromotionGroupToCart = (promotionGroupId, quantity) => {
  return $.ajax({
    url: `${config.localeApi}/cart/promotionGroup`,
    data: { promotion_group_id: promotionGroupId, quantity: quantity },
    method: 'POST',
    dataType: 'json',
  });
}

export const getGalleryForPromotion = ( promotionId ) => {
  return (
      $.ajax({
          method: 'GET',
          url: `${config.localeApi}/promotions/gallery/${promotionId}`,
      })
  )
}

export const withPromotionMenu = () => WrappedComponent => compose(
  withFetchOnMount(() => $.get(`${config.localeApi}/promotions/menu`)
    .fail(({ responseJSON: { errors = '' } }) => {
      showErrorMsg(errors);
    })),
    mapProps(({ loading, data, ...keys }) => ({
      data: camelize(data.data),
      ...keys,
    })),
)(WrappedComponent);



// WEBPACK FOOTER //
// ./src/Common/Providers/PromotionApi.js